import { api } from "../../../utils/api";

export const scheduleReadjust = async (data) => {
  try {
    const response = await api.post('schedule/readjust-sale', data);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};
